import bookingWidgetModalCtrl from 'services/modal/bookingWidget/bookingWidgetModalCtrl';
import completeProfileModalCtrl from 'services/modal/completeProfile/completeProfileModalCtrl';
import contactSupportModalCtrl from 'services/modal/contactSupport/contactSupportModalCtrl';
import earnCreditModalCtrl from 'services/modal/earnCredit/earnCreditModalCtrl';
import editCitiesModalCtrl from 'services/modal/editCities/editCitiesModalCtrl';
import editContactInformationModalCtrl from 'services/modal/editContactInformation/editContactInformationModalCtrl';
import editCreditCardModalCtrl from 'services/modal/editCreditCard/editCreditCardModalCtrl';
import editMembershipModalCtrl from 'services/modal/editMembership/editMembershipModalCtrl';
import editProfileModalCtrl from 'services/modal/editProfile/editProfileModalCtrl';
import enterPromoModalCtrl from 'services/modal/enterPromo/enterPromoModalCtrl';
import forgotPasswordModalCtrl from 'services/modal/forgotPassword/forgotPasswordModalCtrl';
import getMembershipModalCtrl from 'services/modal/getMembership/getMembershipModalCtrl';
import loginModalCtrl from 'services/modal/login/loginModalCtrl';
import searchModalCtrl from 'services/modal/search/searchModalCtrl';
import shareLinkModalCtrl from 'services/modal/shareLink/shareLinkModalCtrl';
import termsModalCtrl from 'services/modal/terms/termsModalCtrl';
import confirmationModalCtrl from 'services/modal/confirmation/controller';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('bookingWidgetModalCtrl', bookingWidgetModalCtrl);
  app.controller('completeProfileModalCtrl', completeProfileModalCtrl);
  app.controller('contactSupportModalCtrl', contactSupportModalCtrl);
  app.controller('earnCreditModalCtrl', earnCreditModalCtrl);
  app.controller('editCitiesModalCtrl', editCitiesModalCtrl);
  app.controller('editContactInformationModalCtrl', editContactInformationModalCtrl);
  app.controller('editCreditCardModalCtrl', editCreditCardModalCtrl);
  app.controller('editMembershipModalCtrl', editMembershipModalCtrl);
  app.controller('editProfileModalCtrl', editProfileModalCtrl);
  app.controller('enterPromoModalCtrl', enterPromoModalCtrl);
  app.controller('forgotPasswordModalCtrl', forgotPasswordModalCtrl);
  app.controller('getMembershipModalCtrl', getMembershipModalCtrl);
  app.controller('loginModalCtrl', loginModalCtrl);
  app.controller('searchModalCtrl', searchModalCtrl);
  app.controller('shareLinkModalCtrl', shareLinkModalCtrl);
  app.controller('termsModalCtrl', termsModalCtrl);
  app.controller('confirmationModalCtrl', confirmationModalCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/services/modal/index.js